import OpenApiClient from './OpenApiClient'

const openClient = new OpenApiClient()

export default {
  /**
   * 一般：サーバ時間取得
   */
  getTimestamp () {
    return openClient.get('/op/timestamp')
  }
}
